import { AppList } from '@ui/applications';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { DetailSubsection } from './DetailSubsection';
import { FeatureBoundary } from '@ui/features';
import { FeatureFlag } from '@sonar-software/sonar-core';
import React from 'react';
import { useSonarObjectReference } from '@hooks';

export interface IngestedBySectionProps {
	sonarObjectId: number;
}

export const IngestedBySection: React.FC<IngestedBySectionProps> = ({ sonarObjectId }) => {
	const { ingestedBy } = useSonarObjectReference(sonarObjectId);

	return (
		<FeatureBoundary feature={ FeatureFlag.DataSecurityDashboard }>
			<DetailSubsection
				className='inline-metadata'
				count={ ingestedBy.length }
				title={ COPY_SPECIFIC.READ_BY }>
				<AppList
					appIds={ ingestedBy }
					direction='horizontal' />
			</DetailSubsection>
		</FeatureBoundary>
	);
};
